import _sfc_main from './src/tooltip.vue2.mjs';
export { tooltipEmits, useTooltipModelToggle, useTooltipModelToggleEmits, useTooltipModelToggleProps, useTooltipProps } from './src/tooltip.mjs';
export { useTooltipTriggerProps, useTooltipTriggerPropsDefaults } from './src/trigger.mjs';
export { useTooltipContentProps, useTooltipContentPropsDefaults } from './src/content.mjs';
export { TOOLTIP_INJECTION_KEY } from './src/constants.mjs';
import { withInstall } from '../../utils/vue/install.mjs';

const ElTooltip = withInstall(_sfc_main);

export { ElTooltip, ElTooltip as default };
//# sourceMappingURL=index.mjs.map
